import cardCopy from "./english-journey-card-copy.json";

type DisplayChapter = {
  id: string;
  unitNumber?: number;
  unitTitle?: string;
  title: string;
  learnerDescription: string;
  objective: string;
  cefrCanDo: string;
  newConcept?: string;
  challengeGloss?: string;
  sampleChallenge: string;
};

type DisplayJourney = {
  progressNamespace?: string;
  instructionLanguage: string;
  instructionLanguageCode?: string;
  learnerCopyMode?: "authored";
  chapters: DisplayChapter[];
  courseUnits?: Array<{ unitNumber: number; title: string; canDo: string }>;
  cefrLevels: Array<{ chapterStart: number; canDo: string }>;
};

const chapters: Record<string, string[]> = cardCopy.chapters;
const units: Record<string, string[]> = cardCopy.units;

export function localizeEnglishJourneyForDisplay<T extends DisplayJourney>(
  journey: T,
  instructionLanguageCode?: string | null
): T {
  if (journey.progressNamespace !== "english-es-v1") return journey;
  const instructionBase = instructionLanguageCode
    ?.trim()
    .replace(/_/g, "-")
    .toLowerCase()
    .split("-")[0];
  if (instructionBase === "es") return journey;

  return {
    ...journey,
    instructionLanguage: "English",
    instructionLanguageCode: "en-US",
    learnerCopyMode: "authored",
    courseUnits: journey.courseUnits?.map((unit) => ({
      ...unit,
      title: units[String(unit.unitNumber)][0],
      canDo: units[String(unit.unitNumber)][1],
    })),
    cefrLevels: journey.cefrLevels.map((level) => ({
      ...level,
      canDo: chapters[`english-es-v1-${String(level.chapterStart).padStart(3, "0")}`][3],
    })),
    chapters: journey.chapters.map((chapter) => {
      const [title, learnerDescription, objective, cefrCanDo] = chapters[chapter.id];
      return {
        ...chapter,
        title,
        learnerDescription,
        objective,
        cefrCanDo,
        unitTitle: units[String(chapter.unitNumber)][0],
        newConcept: title,
        challengeGloss: chapter.sampleChallenge,
      };
    }),
  };
}
